import { render, staticRenderFns } from "./CustomReport.vue?vue&type=template&id=54c33fd7&scoped=true"
import script from "./CustomReport.vue?vue&type=script&lang=js"
export * from "./CustomReport.vue?vue&type=script&lang=js"
import style0 from "./CustomReport.vue?vue&type=style&index=0&id=54c33fd7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c33fd7",
  null
  
)

export default component.exports